import styled from '@emotion/styled';
import {Box, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Typography} from '@mui/material';
import {LatestUpdateItemDTO, LatestUpdateSection, Section, Status} from '../../../../api/models';
import {useState} from 'react';
import {LatestUpdateType} from '../../../../api/latestupdate';
import {LatestUpdateComponent} from './LatestUpdateComponent';
import {AddNewMediaUpdateComponent} from './AddNewMediaUpdateComponent';
import {AddNewTextUpdateComponent} from './AddNewTextUpdateComponent';

const BackgroundBoxWrapper = styled(Box)<{backgroundColor: string}>(({backgroundColor}) => ({
    // paddingTop: 32,
    paddingLeft: 54,
    paddingRight: 54,
    paddingBottom: 32,
    margin: 0,
    backgroundColor: backgroundColor,
}));

interface Props {
    section: Section;
    websiteId: string;
    throwSnackbarMessage: (message: string) => void;
    refetch: VoidFunction;
}

export const LatestUpdateCompanionComponent = (props: Props) => {
    const [updateType, setUpdateType] = useState<LatestUpdateType | undefined>(undefined);
    const {section} = props;
    const latestUpdateSection = section as LatestUpdateSection;

    const getLatestUpdate = (updates: LatestUpdateItemDTO[]): LatestUpdateItemDTO | undefined => {
        const filteredUpdates = updates.filter((update) => update.status === Status.ACTIVE);
        if (filteredUpdates.length > 0) {
            return filteredUpdates[0];
        } else {
            return undefined;
        }
    };

    const latestUpdate = getLatestUpdate(latestUpdateSection.latestUpdate);
    let el = <></>;

    switch (updateType) {
        case 'Text':
            el = (
                <AddNewTextUpdateComponent throwSnackbarMessage={props.throwSnackbarMessage} refetch={props.refetch} />
            );
            break;
        case 'Image':
        case 'Video':
            el = (
                <AddNewMediaUpdateComponent
                    throwSnackbarMessage={props.throwSnackbarMessage}
                    updateType={updateType}
                    refetch={props.refetch}
                />
            );
            break;
        default:
            break;
    }

    return (
        <div>
            <BackgroundBoxWrapper backgroundColor={'white'}>
                <Grid container>
                    <Grid item md={12} xs={12} sm={12}>
                        <Typography
                            sx={{
                                marginTop: 1,
                                fontWeight: 700,
                                color: 'black',
                                fontFamily: 'Poppins',
                            }}
                            variant='body1'>
                            Add a new update
                        </Typography>
                    </Grid>
                </Grid>
                <br />
                <Grid container>
                    <Grid item md={12} xs={12} sm={12}>
                        <Box sx={{minWidth: 320}}>
                            <FormControl fullWidth>
                                <InputLabel id='update-type-label'>Update Type</InputLabel>
                                <Select
                                    labelId='update-type-label'
                                    id='update-type-select'
                                    value={updateType}
                                    label='Update Type'
                                    onChange={(handleChange: SelectChangeEvent) => {
                                        setUpdateType(handleChange.target.value as LatestUpdateType);
                                    }}>
                                    <MenuItem value={'Text'}>Text</MenuItem>
                                    <MenuItem value={'Image'}>Image</MenuItem>
                                    <MenuItem value={'Video'}>Video</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>
                </Grid>
                <br />
                {el}
                <br />
                <LatestUpdateComponent update={latestUpdate} />
            </BackgroundBoxWrapper>
        </div>
    );
};
